import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from './en';
import russianMessages from './ru';
import czechMessages from './cs';
import ukrainianMessages from './ua';

// Locale-code convention: cs/en/ua/ru (per project memory; Ukrainian is `ua`,
// NOT BCP-47 `uk`). cs + ua currently only override the D2 "Build-your-own-
// bouquet" admin keys and inherit English for everything else — see cs.ts / ua.ts.
const translations: Record<string, any> = {
  en: englishMessages,
  ru: russianMessages,
  cs: czechMessages,
  ua: ukrainianMessages,
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale] || translations.en,
  'en', // default locale
  [
    { locale: 'en', name: 'English' },
    { locale: 'ru', name: 'Русский' },
    { locale: 'cs', name: 'Čeština' },
    { locale: 'ua', name: 'Українська' },
  ]
);

export const availableLocales = [
  { locale: 'en', name: 'English', flag: '🇬🇧' },
  { locale: 'ru', name: 'Русский', flag: '🇷🇺' },
  { locale: 'cs', name: 'Čeština', flag: '🇨🇿' },
  { locale: 'ua', name: 'Українська', flag: '🇺🇦' },
];

export default i18nProvider;
